export default __webpack_public_path__ + "static/media/close.03e15148.png";